import { render, staticRenderFns } from "./UserRole.vue?vue&type=template&id=435b7b04&scoped=true&"
import script from "./UserRole.vue?vue&type=script&lang=js&"
export * from "./UserRole.vue?vue&type=script&lang=js&"
import style0 from "./UserRole.vue?vue&type=style&index=0&id=435b7b04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435b7b04",
  null
  
)

export default component.exports